import { DateTimeInput, Field, NumericInput, TextInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection, SectionGroup } from 'Components/Layout';
import { IWorksheetComponent, WorksheetBalanceFieldSet, WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { ISieveSize } from 'Data/ViewModels/Equipment/ISieveSize';
import { hasValue } from 'Lib/Any';
import { useSelector } from 'react-redux';
import BsEnPortionDryMassReadings from './PortionDryMassReadingsSection';

interface IBsEnPortionDryMassSection extends IWorksheetComponent {
  label: string;
  hideConstantDrySoilMass?: boolean;
  showGuardSieve?: boolean;
}

let BsEnPortionDryMassSection: React.FC<IBsEnPortionDryMassSection> = ({
  createWorksheetSelector,
  label,
  hideConstantDrySoilMass,
  showGuardSieve,
}) => {
  const sieveSize = useSelector(createWorksheetSelector!('SieveSize')) as ISieveSize;
  const maximumGuardSieveSize = useSelector(createWorksheetSelector!('MaximumGuardSieveSize')) as ISieveSize;

  return (
    <SectionGroup heading={label}>
      <ListFieldSection>
        <Field input={<TextOutput />} name="SieveSize" value={sieveSize?.Caption} />
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="sieve"
          name="WashingSieve"
          disabled={!hasValue(sieveSize)}
          queryParams={{
            SieveSize: sieveSize ? `${sieveSize?.Size?.value} ${sieveSize?.Size?.uom}` : null,
          }}
        />

        {(showGuardSieve ?? false) && (
          <Field
            input={<WorksheetEquipmentDropdown />}
            equipmentType="sieve"
            name="GuardSieve"
            disabled={!hasValue(maximumGuardSieveSize)}
            queryParams={{
              SieveSize: maximumGuardSieveSize
                ? `2.00 mm:${maximumGuardSieveSize?.Size?.value} ${maximumGuardSieveSize?.Size?.uom}`
                : null,
            }}
          />
        )}

        <Field input={<TextInput />} name="MeasuredConstantDryMass.DryingTray.ContainerLabel" maxLength={20} />
        <Field input={<NumericInput />} name="MeasuredConstantDryMass.DryingTray.ContainerMass" />
        <Field input={<DateTimeInput />} name="MeasuredConstantDryMass.DryingTray.DateTimePlacedInOvenLocal" />
        <WorksheetBalanceFieldSet name="MeasuredConstantDryMass.Equipment.DryMassBalance" />
      </ListFieldSection>

      <NamePrefixModifier appendNamePrefix="MeasuredConstantDryMass">
        <BsEnPortionDryMassReadings />
      </NamePrefixModifier>

      {!(hideConstantDrySoilMass ?? false) && (
        <ListFieldSection>
          <Field input={<TextOutput />} name="MeasuredConstantDryMass.DryingTray.ConstantDrySoilMass" />
        </ListFieldSection>
      )}
    </SectionGroup>
  );
};

BsEnPortionDryMassSection = withInjectedProps(BsEnPortionDryMassSection);

export { BsEnPortionDryMassSection };
export default BsEnPortionDryMassSection;
